import { Injectable } from '@angular/core';

@Injectable()
export class StringUtils {
	public normalizeStringInLowercaseWithoutAccent(str: string): string {
		return str
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '')
			.toLowerCase();
	}
}
